<div class="card">
  <div class="card-body">
    <app-loading-placeholder [width]="'100%'"
      [height]="height"
      [marginBottom]="'20px'">
    </app-loading-placeholder>
    <app-loading-placeholder [width]="'65%'"
      [height]="'20px'"
      [marginBottom]="'5px'">
    </app-loading-placeholder>
    <app-loading-placeholder [width]="'85%'"
      [height]="'25px'"
      [marginBottom]="'20px'">
    </app-loading-placeholder>
    <app-loading-placeholder [width]="'30%'"
      [height]="'30px'"
      [display]="'inline-block'">
    </app-loading-placeholder>
    <app-loading-placeholder [width]="'30%'"
      [height]="'30px'"
      [display]="'inline-block'"
      [marginLeft]="'5%'"
      [marginRight]="'5%'">
    </app-loading-placeholder>
    <app-loading-placeholder [width]="'30%'"
      [height]="'30px'"
      [display]="'inline-block'">
    </app-loading-placeholder>
  </div>
</div>
